import { leadConstants } from '../constants'

export const leadReset = () => {
  return {
    type: leadConstants.LEAD_RESET
  }
}

export const leadSave = (payload) => {
  return {
    type: leadConstants.LEAD_SAVE,
    payload
  }
}

export const leadSaveSuccess = (payload) => {
  return {
    type: leadConstants.LEAD_SAVE_SUCCESS,
    payload
  }
}

export const leadSaveFailure = (payload) => {
  return {
    type: leadConstants.LEAD_SAVE_FAILURE,
    payload
  }
}

export const leadPatch = (payload) => {
  return {
    type: leadConstants.LEAD_PATCH,
    payload
  }
}

export const leadPatchSuccess = () => {
  return {
    type: leadConstants.LEAD_PATCH_SUCCESS
  }
}

export const leadPatchFailure = (payload) => {
  return {
    type: leadConstants.LEAD_PATCH_FAILURE,
    payload
  }
}
